import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { LazyLoadEvent } from 'primeng/api';
import { ManufacturerWizard } from '../../domain/eurocode';

@Component({
  selector: 'app-admin-manufacturers',
  templateUrl: './admin-manufacturers.component.html',
  styleUrls: ['./admin-manufacturers.component.scss']
})
export class AdminManufacturersComponent {
  // virtualManufacturers: ManufacturerWizard[] = [];
  // totalRecords: number = 0;
  // loading: boolean = true;
  // rows: number = 10;

  // constructor(private adminService: AdminService, private router: Router) {}



  // ngOnInit(): void {
  //   const storedQuery = localStorage.getItem('manuQuery');
  //   const storedQueryDate = localStorage.getItem('manuQueryDate');
  //   if (storedQuery && storedQueryDate) {
  //     const queryDate = new Date(storedQueryDate);
  //     const now = new Date();
  //     const diffInHours = (now.getTime() - queryDate.getTime()) / (1000 * 60 * 60);
  //     if (diffInHours < 2) {
  //       this.query = storedQuery;
  //     }
  //   }
  //   //this.loadCodes({ first: 0, rows: this.rows });
  // }

  // set query(value: string) {
  //   this._query = value;
  //   localStorage.setItem('manuQuery', value);
  //   localStorage.setItem('manuQueryDate', new Date().toISOString());
  // }

  // get query(): string {
  //   return this._query;
  // }
  // private _query: string = '';


  // loadManufacturers(event: LazyLoadEvent): void {
  //   this.loading = true;
  //   const page = 1+(event.first! / event.rows!);
  //   const size = event.rows!;

  //   this.adminService.getManufacturersPaged(page, size, this.query).subscribe(
  //     response => {
  //       this.virtualManufacturers = response.Data;
  //       this.totalRecords = response.TotalRecords;
  //       this.loading = false;
  //     },
  //     error => {
  //       console.error('Error fetching manufacturers', error);
  //       this.loading = false;
  //     }
  //   );
  // }

  // goBack(id: number) {
  //   this.router.navigate(['admin-dashboard']);
  // }
  // edit(item: ManufacturerWizard): void {
  //   this.router.navigate(['admin-manufacturers', item.ManId]);
  // }

  // delete(item: ManufacturerWizard): void {
  //   // Implement delete logic here
  // }

  // createNewManufacturer(): void {
  //   this.router.navigate(['admin-manufacturers/new']);
  // }
}
